import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const ServiceFlagsContext = createContext({});

export const ServiceFlagsProvider = ({ children }) => {
  const [flags, setFlags] = useState({});

  useEffect(() => {
    axios.get(`${API}/api/service-flags`)
      .then(({ data }) => setFlags(data.flags || {}))
      .catch(() => {});
  }, []);

  const isEnabled = (key) => !key || flags[key] !== false;

  return (
    <ServiceFlagsContext.Provider value={{ flags, isEnabled }}>
      {children}
    </ServiceFlagsContext.Provider>
  );
};

export const useServiceFlags = () => useContext(ServiceFlagsContext);
